const typs = {
    'forward-as-success': 'האם אתה בטוח שתרצה לשמור ולהעביר לאדמין כהצלחה?',
    'forward-as-failure': 'האם אתה בטוח שתרצה לשמור ולהעביר לאדמין ככשלון?',
    'returned-for-changes': 'האם אתה בטוח שתרצה להחזיר לתיקון?',
    'forward-to-selected': 'האם אתה בטוח שתרצה להעביר לבעל התפקיד הבא?',
    'save-only': 'האם אתה בטוח שתרצה לשמור את השינויים?',
    'discard-changes': 'האם אתה בטוח שתרצה למחוק את השינויים?',
    'save-thumbnails': 'האם אתה בטוח שתרצה לשמור את השינויים?',
    'finish-thumbnails': 'האם אתה בטוח שתרצה להגיש את הטאמבניילים לבדיקה?',
    'archive': 'האם אתה בטוח שתרצה להעביר סרטון זה לארכיון?',
}

export function VideoPopup({ close, type, onConfirm }) {
    return <>
        <div className="screen blur" onClick={close} />
        <section className='popup' style={{ width: 'max-content' }}>
            <p style={{fontSize:'22px',padding:'0 10px'}}>{typs[type]}</p>
            <div className='buttons-wrapper'>
                <div onClick={close} className='lighter'>ביטול</div>
                <div onClick={() => onConfirm(type)} className='bolder'>אישור</div>
            </div>
        </section>
    </>
}